import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

export const MobileNav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #2e1c65;
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 16px;
`;

export const MobileHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MobileLogo = styled.div`
  display: flex;
  align-items: center;
  height: 32px;

  & svg {
    height: 32px;
  }
`;

export const MobileRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const MobileBalance = styled.div`
  color: #fff;
  font-size: 14px;
  display: flex;
  align-items: center;

  & img {
    margin-right: 6px;
    height: 18px;
  }
`;

export const BurgerButton = styled.button<{ $open: boolean }>`
  position: relative;
  width: 28px;
  height: 20px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & span {
    display: block;
    height: 2px;
    width: 80%;
    background: #fff; // белые линии
    border-radius: 2px;
    transition: 0.3s;
  }

  ${({ $open }) =>
    $open &&
    css`
      & span {
        opacity: 0; // скрываем линии, если меню открыто
      }
    `}
`;

export const CloseButton = styled.button`
  width: 28px;
  height: 28px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 20px;
    height: 2px;
    background: #fff; // белые линии
    border-radius: 2px;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

export const SidebarOverlay = styled.div<{ $open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: ${({ $open }) => ($open ? "100%" : "0")};
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  transition: 0.3s;
  z-index: 999;
`;

export const Sidebar = styled.div<{ $open?: boolean }>`
  position: fixed;
  top: 0;
  right: ${({ $open }) => ($open ? "0" : "-100%")};
  width: 280px;
  height: 100vh;
  background: #2e1c65;
  z-index: 1000;
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const SidebarHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SidebarUser = styled.div`
  color: #fff;
  font-size: 16px;
  font-weight: 600;
`;

export const SidebarMenu = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 16px;
`;

export const SidebarLink = styled(Link)<{ $active?: boolean; $level?: number }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  padding-left: ${({ $level }) => 20 + ($level || 0) * 15}px;
  font-size: 16px;
  color: ${({ $active }) => ($active ? "#cd6ee5" : "#fff")};
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    color: #cd6ee5;
  }
`;

export const Arrow = styled.span<{ $open?: boolean }>`
  margin-left: auto;
  width: 10px;
  height: 10px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: ${({ $open }) => ($open ? "rotate(45deg)" : "rotate(-45deg)")};
  transition: transform 0.3s ease;
`;

export const Submenu = styled.div<{ $open?: boolean }>`
  max-height: ${({ $open }) => ($open ? "1000px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease;
`;

export const SubLink = styled(Link)<{ $active?: boolean }>`
  display: block;
  padding: 10px 40px;
  font-size: 14px;
  color: ${({ $active }) => ($active ? "#cd6ee5" : "#ddd")};
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  text-decoration: none;
  border-left: ${({ $active }) =>
    $active ? "3px solid #cd6ee5" : "3px solid transparent"};
  background: ${({ $active }) =>
    $active ? "rgba(205, 110, 229, 0.08)" : "transparent"};
  transition: all 0.3s ease;

  &:hover {
    color: #cd6ee5;
    background: rgba(205, 110, 229, 0.05);
  }
`;

export const AccordionHeader = styled.div<{
  $active?: boolean;
  $level?: number;
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  padding-left: ${({ $level }) =>
    20 + ($level || 0) * 15}px; // смещение по уровню
  font-size: 16px;
  color: ${({ $active }) => ($active ? "#cd6ee5" : "#fff")};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: #cd6ee5;
  }
`;
